import { FieldsErrors } from '@alfa-retail-react/components';
import ErrorContextToFieldConverter from '@alfa-retail-react/components/converter/ErrorContextToFieldConverter';

export const getConvertedErrors = (
    errors: FieldsErrors<any>,
    contextConverter: ErrorContextToFieldConverter<any>,
): FieldsErrors<string> => {
    const errorsMap = new Map(errors);
    const result = new Map(errors);

    errorsMap.forEach((value, key) => {
        const convertedKey = contextConverter.convert(key)[0];

        if (!!convertedKey) {
            result.delete(key);
            result.set(convertedKey, value);
        }
    });

    return result;
};
